export const environment = {
  // API_URL: 'http://localhost:3000/api',
  PRODUCTION: false,
  API_URL: '/api', // 'https://smartflowg.cloud.reserv.com.ar/api',
  API_URL_MOCK: 'https://dummyjson.com',
};
